import { forwardRef, type InputHTMLAttributes } from 'react';
import { inputClasses } from './Field';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { invalid, className, ...props },
  ref,
) {
  return <input ref={ref} aria-invalid={invalid || undefined} className={inputClasses(invalid, className)} {...props} />;
});
